export default {
	getAuthEnv() {
		let authEnv = 'https://www.webmd.com/search/2/api/';
		let host;
		let isNonProd = false;
		if (typeof window !== 'undefined') {
			host = window.location.host.toLowerCase() || window.location.hostname;
			authEnv = '';
			if (host.indexOf('localhost') >= 0 || host.indexOf('.devint') >= 0 || host.indexOf('.feature') >= 0) {
				authEnv = 'https://www.webmd.com/search/2/api/';
				isNonProd = true;
			} else if (host.indexOf('.qa') > 0 || host.indexOf('.qa01') > 0) {
				authEnv = 'https://www.qa01.webmd.com/search/2/api/';
				isNonProd = true;
			} else if (host.indexOf('.preview') > 0) {
				authEnv = 'https://www.preview.webmd.com/search/2/api/';
				isNonProd = true;
			} else if (host.indexOf('.staging') > 0) {
				authEnv = 'https://www.staging.webmd.com/search/2/api/';
				isNonProd = false;
			} else {
				authEnv = 'https://www.webmd.com/search/2/api/';
				isNonProd = false;
			}
		}
		return {
			authEnv,
			isNonProd,
		};
	},
};
